import {
  dayMonthDateString,
  Shift,
  shiftTimeRangeDurationString,
} from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'

interface Props {
  shift: Shift
}
export function CalledOutShiftDetails(props: Props) {
  const styles = useStyles()
  return (
    <View style={styles.card}>
      <View style={[styles.calledOutShiftDetailsRow, styles.dateTimeRow]}>
        <Text style={styles.date}>{dayMonthDateString(props.shift.date)}</Text>
        <Text style={styles.time}>
          {shiftTimeRangeDurationString(props.shift)}
        </Text>
      </View>
      <View style={[styles.calledOutShiftDetailsRow, styles.namePositionRow]}>
        {props.shift.user ? (
          <Text style={styles.shiftPosition}>
            {`${props.shift.user.firstName} ${props.shift.user.lastName}`}
          </Text>
        ) : null}

        <Text style={styles.shiftPosition}>
          {props.shift.position ?? t('anyPosition')}
        </Text>
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  card: {
    justifyContent: 'center',
    backgroundColor: theme.colors?.white,
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    marginBottom: 17,
  },
  dateTimeRow: { marginTop: 20, marginBottom: 10 },
  date: {
    fontSize: 19,
    fontFamily: font.bold,
  },
  time: {
    fontSize: 16,
    color: theme.colors?.grey1,
  },
  namePositionRow: { marginBottom: 20 },
  shiftPosition: {
    fontSize: 17,
  },
  calledOutShiftDetailsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 10,
  },
}))
